"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProvider = void 0;
class KHInputProvider {
    /**
     *
     * @param delay Start delay in MILLIs
     * @param duration Duration in MILLIs
     * @param weak Magnitude of weak rumble (0-1)
     * @param strong Magnitude of strong rumble (0-1)
     */
    tryVibrate(delay, duration, weak, strong) {
        // Default is no implementation.
    }
    type() {
        return null;
    }
}
exports.KHInputProvider = KHInputProvider;
